import React, { useState, useMemo } from "react";
import "./FgListDialog.css";

export default function FgListDialog({ fgList, stage, onClose, onItemClick }) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredList = useMemo(() => {
    if (!searchQuery) return fgList;
    return fgList.filter((fg) =>
      fg.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [fgList, searchQuery]);

  return (
    <div className="fg-dialog-backdrop" onClick={onClose}>
      <div className="fg-dialog-card" onClick={(e) => e.stopPropagation()}>
        <header className="fg-dialog-header">
          <div className="header-text">
            <h2>FG Numbers</h2>
            <span className="stage-badge">{stage}</span>
          </div>
          <button className="icon-close-top" onClick={onClose}>&times;</button>
        </header>

        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search FG reference..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="fg-search-input"
          />
          <span className="search-icon">🔍</span>
        </div>

        <div className="fg-list-container">
          {filteredList.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">📂</div>
              <p>No matches found for "{searchQuery}"</p>
            </div>
          ) : (
            <ul className="fg-list">
              {filteredList.map((fg, idx) => (
                <li 
                  key={idx} 
                  className="fg-list-item interactive-fg-row"
                  onClick={() => {
                    if (typeof onItemClick === "function") {
                      onItemClick(fg);
                    }
                  }}
                  style={{ cursor: "pointer" }} // Fallback inline rule to guarantee pointer indicator
                >
                  <span className="fg-text">{fg}</span>
                  <span className="redirect-arrow" style={{ color: "#0d47a1", fontWeight: "bold" }}>➔</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <footer className="fg-dialog-footer">
          <button className="btn-action-close" onClick={onClose}>
            Dismiss
          </button>
        </footer>
      </div>
    </div>
  );
}